import { Dispatch, SetStateAction, useImperativeHandle, useState, Ref } from 'react';
import { FilterState } from '../FiltersArea';
import { OptionsRangeFilter } from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';
import { Resettable } from '@/models/Resettable';

interface AmountFilterProps {
  setFilterState: Dispatch<SetStateAction<FilterState>>;
  ref?: Ref<Resettable>;
}

const AmountFilter = ({ setFilterState, ref }: AmountFilterProps) => {
  const [fromValue, setFromValue] = useState<string>('');
  const [toValue, setToValue] = useState<string>('');
  const [appliedRange, setAppliedRange] = useState<{ from: string; to: string } | null>(null);

  const handleRangeApply = (from: string, to: string) => {
    setFilterState((prev) => ({
      ...prev,
      amount: { from, to },
    }));
  };

  useImperativeHandle(ref, () => ({
    reset: () => {
      setFromValue('');
      setToValue('');
      setAppliedRange(null);
    },
  }));

  return (
    <OptionsRangeFilter
      title="amountRange"
      filterType="range"
      rangeConfig={{
        type: 'number',
        fromPlaceholder: 'minAmount',
        toPlaceholder: 'maxAmount',
      }}
      fromValue={fromValue}
      setFromValue={setFromValue}
      toValue={toValue}
      setToValue={setToValue}
      appliedRange={appliedRange}
      setAppliedRange={setAppliedRange}
      onRangeApply={handleRangeApply}
    />
  );
};

export default AmountFilter;
